import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { RenderSVG } from '../../common/render-svg';
import Standard from './assets/standard.svg';
export var RichIconSearch = function RichIconSearch(props) {
  return /*#__PURE__*/React.createElement(RenderSVG, _extends({
    src: Standard
  }, props));
};